import {useRive} from '@rive-app/react-canvas';

export const CheckmarkAnimation = ({onEnded}: {onEnded: () => void}) => {
  const {RiveComponent} = useRive({
    src: '/checkmark_animation.riv',
    autoplay: true,
    stateMachines: 'controller',
    artboard: 'Artboard',
    onStateChange: (e) => {
      if ((Array.isArray(e.data) ? e.data?.[0] : e.data) === 'exit') onEnded();
    },
  });

  return <RiveComponent />;
};
